module.exports = __webpack_public_path__ + "img/fundingResolutionLogo6.e9744b37.png";